var styles = {
  "Icon": "_Icon_146h8_1",
  "Svg": "_Svg_146h8_6",
  "disabled": "_disabled_146h8_16"
};

export { styles as default };
